import { render, staticRenderFns } from "./QuotationStepCustomer.vue?vue&type=template&id=bd8f045e&scoped=true"
import script from "./QuotationStepCustomer.vue?vue&type=script&lang=js"
export * from "./QuotationStepCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd8f045e",
  null
  
)

export default component.exports